import pick from 'lodash/pick';
import omit from 'lodash/omit';

import React from 'react';
import PropTypes from 'prop-types';

import CheckBoxComponent from './Component';

export default CheckBoxComponent;

const CheckBoxContainer = ({ input, ...props }) => {
  const reduxFormProperties = pick(input, ['value', 'onChange', 'className']);

  const dropdownProperties = omit(props, ['meta']);

  return <CheckBoxComponent {...dropdownProperties} {...reduxFormProperties} />;
};

CheckBoxContainer.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.bool,
      PropTypes.string
    ]),
    onChange: PropTypes.func.isRequired
  }).isRequired,

  options: PropTypes.array
};

export { CheckBoxContainer as ReduxFormWrapper };
